import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {EstimateDocument} from '@accounting/_common/models/estimate.models';

export const CheckState = createAction(
    '[Estimates] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: EstimateDocument[] } }>()
);

export const CheckStateSuccess = createAction(
    '[Estimates] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: EstimateDocument[] } }>()
);

export const LoadList = createAction(
    '[Estimates] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Estimates] Load List Success',
    props<{ payload: { items: EstimateDocument[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Estimates] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Estimates] Set Pagination',
    props<{ payload: boolean }>()
);
//
// export const SetFilter = createAction(
//     '[Estimates] Set Filter',
//     props<{ payload: EstimateSearchParams }>()
// );

export const SetLoading = createAction(
    '[Estimates] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Estimates] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[Estimates] Update Item Success',
    props<{ payload: EstimateDocument }>()
);

export const DeleteItem = createAction(
    '[Estimates] Delete Item',
    props<{ payload: EstimateDocument }>()
);

export const DeleteItemSuccess = createAction(
    '[Estimates] Delete Item Success',
    props<{ payload: EstimateDocument }>()
);

export const DeleteItemFailure = createAction(
    '[Estimates] Delete Item Failure',
    props<{ payload: EstimateDocument }>()
);

export const SetInitialState = createAction(
    '[Estimates] Set Initial State'
);
